module.exports = __webpack_public_path__ + "img/share_profit.148a2069.svg";